import { FC } from 'react';
import { Table, Form } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';

import { RsCheckboxTable, useTableSort } from 'components/Rsuite/Table';

import {
  ManualKeywordProperty,
  ManualKeywordWithSuggestType,
  MANUAL_UNIQUE_KEY,
} from 'core/rtbCampaign/singlePage/keyword';

import { BlurNumberInput } from '../BlurNumberInput';
import styles from './chosenKeywordTable.module.scss';

type KeyType = ManualKeywordWithSuggestType[typeof MANUAL_UNIQUE_KEY];

const SUGGEST_PRICE = 'suggestPrice';

interface ChosenKeywordTableProps {
  data: ManualKeywordWithSuggestType[];
  checkedKeys: Set<KeyType>;
  onBidChange: (key: KeyType, value: any) => void;
  onDelete: (key: KeyType) => void;
  onSelect: (v: KeyType) => void;
  onAllSelect: () => void;
  keywordErrorsMap?: Record<string, any>;
}

export const ChosenKeywordTable: FC<ChosenKeywordTableProps> = ({
  data = [],
  checkedKeys,
  onBidChange,
  onDelete,
  onSelect,
  onAllSelect,
  keywordErrorsMap = [],
}) => {
  const { sortedData, sortColumn, sortType, handleSortColumn } =
    useTableSort(data);

  return (
    <RsCheckboxTable
      uniqueKey={MANUAL_UNIQUE_KEY}
      data={sortedData}
      className={styles.ChosenKeywordTable}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      onAllSelect={onAllSelect}
      tableConfig={{
        autoHeight: true,
        maxHeight: 420,
        rowHeight: 48,
        virtualized: true,
        sortColumn,
        sortType,
        shouldUpdateScroll: false,
        onSortColumn: handleSortColumn,
      }}
    >
      <Table.Column flexGrow={1} sortable fullText>
        <Table.HeaderCell>關鍵字</Table.HeaderCell>
        <Table.Cell dataKey={ManualKeywordProperty.KEYWORD} />
      </Table.Column>

      <Table.Column flexGrow={1} sortable>
        <Table.HeaderCell>推薦出價</Table.HeaderCell>
        <Table.Cell dataKey={SUGGEST_PRICE}>
          {(item) => {
            if (item[SUGGEST_PRICE]) {
              return `NTD ${item[SUGGEST_PRICE]}`;
            }
            return '-';
          }}
        </Table.Cell>
      </Table.Column>

      <Table.Column flexGrow={1} sortable>
        <Table.HeaderCell>點擊出價</Table.HeaderCell>
        <Table.Cell
          dataKey={ManualKeywordProperty.PRICE}
          className={styles['bid-price-cell']}
        >
          {(item, rowIndex) => (
            <div className='relative'>
              <BlurNumberInput
                key={item[MANUAL_UNIQUE_KEY]}
                num={item[ManualKeywordProperty.PRICE]}
                onChange={(newPrice) =>
                  onBidChange(item[MANUAL_UNIQUE_KEY], newPrice)
                }
              />
              <Form.ErrorMessage
                show={!!keywordErrorsMap[item[MANUAL_UNIQUE_KEY]]}
                placement='leftStart'
              >
                {
                  keywordErrorsMap[item[MANUAL_UNIQUE_KEY]]?.[
                    ManualKeywordProperty.PRICE
                  ]
                }
              </Form.ErrorMessage>
            </div>
          )}
        </Table.Cell>
      </Table.Column>

      <Table.Column width={100} align='center'>
        <Table.HeaderCell>操作</Table.HeaderCell>
        <Table.Cell>
          {({ [MANUAL_UNIQUE_KEY]: uniqueKey }) => {
            return (
              <TrashIcon
                className='cursor-pointer'
                onClick={() => onDelete(uniqueKey)}
              />
            );
          }}
        </Table.Cell>
      </Table.Column>
    </RsCheckboxTable>
  );
};
